import { clone, findIndex, or, propEq } from 'ramda'
import { zip, sum, isFinite } from 'lodash'
import { enums } from '@bluecrew/bluecrew-lib'
import format from 'date-fns/format'
import startOfWeek from 'date-fns/start_of_week'
import differenceInMinutes from 'date-fns/difference_in_minutes'
import getDay from 'date-fns/get_day'
import addHours from 'date-fns/add_hours'
import subHours from 'date-fns/sub_hours'

import moment from 'moment'
import detailsTemplate from './details/template.html'
import detailsController from './details/controller.js'

import messageController from './message/controller.js'
import messageTemplate from './message/template.html'
import noteController from './note/controller.js'
import noteTemplate from './note/template.html'
import showJobsCtrl from '../job/showJobs/showJobs.ctrl'
import showJobsTpl from '../job/showJobs/showJobs.html'

import actionReasonController from './timesheets/status-change/controller.js'
import actionReasonTemplate from './timesheets/status-change/template.html'

import { defaultPositionRadii, toMetric } from '../../shared/radii'
import { TIMETRACKING_LEGACY_VIEW_SPLIT_NAME } from '../../constants'

const dateToTimeString = function (date, useAmPm, useMilitary) {
  if (useAmPm == null) {
    useAmPm = true
  }

  var hours = date.getHours()
  var minutes = date.getMinutes()
  var ending = (hours >= 12 ? 'PM' : 'AM')
  if (!useMilitary) {
    hours = (hours % 12) || 12
  }
  minutes = (minutes < 10 ? '0' + minutes : minutes)
  return (hours + ':' + minutes + (useAmPm ? ' ' + ending : ''))
}

const dateCellToISODate = function (d) {
  var dateComponents = d.match(/[^ ]+ ([0-9]+)\/([0-9]+)\/([0-9]+)/)

  if (!dateComponents) {
    return ''
  }

  dateComponents.shift()
  dateComponents.map(function (component) {
    return parseInt(component)
  })

  var pad = function (num) {
    return (num < 10 ? '0' : '') + num
  }

  return pad(dateComponents[2]) + '/' + pad(dateComponents[0]) + '/' + pad(dateComponents[1])
}
const dateSorter = function (a, b) {
  return dateCellToISODate(a).localeCompare(dateCellToISODate(b))
}
const monetarySorter = function (a, b) {
  var dif = (parseFloat(a.substring(1)) - parseFloat(b.substring(1)))
  return (dif == 0 ? 0 : (dif > 0 ? 1 : -1))
}

class PayrollController {
  /* @ngInject */
  constructor (week, company, Auth, CompaniesService, JobsService, PayrollService, ToastService, UsersService, Shifts, $scope, $stateParams, $mdDialog, $mdToast, Crews, $state, $window) {
    this.PayrollHoursStatus = clone(enums.PayrollHoursStatus)
    this.timesheetTabs = [
      {key: this.PayrollHoursStatus.FOLLOW_UP, label: 'Messaged'},
      {key: this.PayrollHoursStatus.APPROVED, label: 'Approved'},
      {key: this.PayrollHoursStatus.EXCUSED, label: 'Excused'},
      {key: this.PayrollHoursStatus.NO_RESPONSE, label: 'No response'},
      {key: this.PayrollHoursStatus.REJECTED, label: 'Rejected'},
      {key: this.PayrollHoursStatus.NEEDS_VERIFICATION, label: 'Need verification'}
    ]

    this.updatedByLabels = {}
    this.updatedByLabels[this.PayrollHoursStatus.APPROVED] = 'approved'
    this.updatedByLabels[this.PayrollHoursStatus.REJECTED] = 'rejected'
    this.updatedByLabels[this.PayrollHoursStatus.FOLLOW_UP] = 'messaged'
    this.updatedByLabels[this.PayrollHoursStatus.EXCUSED] = 'excused'
    this.updatedByLabels[this.PayrollHoursStatus.NO_RESPONSE] = 'marked as no response'

    this.company = company
		this.$state = $state
		this.$window = $window
    this.Auth = Auth
    this.CompaniesService = CompaniesService
    this.JobsService = JobsService
    this.PayrollService = PayrollService
    this.ToastService = ToastService
    this.UsersService = UsersService
    this.Crews = Crews
    this.Shifts = Shifts

    this.$scope = $scope
    this.$stateParams = $stateParams

    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast

    this.mode = 'report'
    this.dataLoaded = false
    this.allCompaniesPayroll
    this.users = {}
    this.jobs = {}
    this.payrollDates = []
    this.currentWeek = week
    this.selectedWeek = week
    this.currentWeekStart = startOfWeek(new Date(), {weekStartsOn: 1})

    this.startDateOfWeek = moment((week * 6.048e8) + 3.744e8).toDate()

    //to begin we want the selected date range of the preview modal to be a single week so
    //we set both the start date and end date to the payroll date selected
    //
    this.invoiceStartDateOfWeek = this.startDateOfWeek
    this.invoiceEndDateOfWeek = this.startDateOfWeek
    this.beginInvoiceWeek = this.startDateOfWeek

    this.selectedDate
    this.selectedCompany
    this.tableDisplay = {
      column: 'needApprovalAllTime',
      reverse: true,
      searchText: ''
    }
    this.QCData = {}

    this.statusChangeReasons = {}

    this.statusChangeReasons[enums.PayrollHoursStatus.APPROVED] = [
      { value: 0, description: 'Employee submitted -  AM approved no adjustments' },
      { value: 1, description: 'AM submitted - internet issue' },
      { value: 2, description: 'AM submitted - forgot timestamp' },
      { value: 3, description: 'AM submitted - location perimeter too small' },
      { value: 4, description: 'AM submitted - terminal issue' },
      { value: 5, description: 'AM submitted - employer offline wr' },
      { value: 6, description: 'AM submitted - no phones work site' },
      { value: 19, description: 'Other' }
    ]

    this.statusChangeReasons[enums.PayrollHoursStatus.REJECTED] = [
      { value: 7, description: 'Resigned' },
      { value: 8, description: 'No Show' },
      { value: 9, description: 'Walkoff' },
      { value: 19, description: 'Other' }
    ]

    this.statusChangeReasons[enums.PayrollHoursStatus.NO_RESPONSE] = [
      { value: 10, description: 'No timestamps' },
      { value: 11, description: 'No clock-out' },
      { value: 12, description: 'Late clock-in' },
      { value: 13, description: 'Late clock-out' },
      { value: 19, description: 'Other' }
    ]

    this.statusChangeReasons[enums.PayrollHoursStatus.EXCUSED] = [
      { value: 14, description: 'Family emergency' },
      { value: 15, description: 'Holiday' },
      { value: 16, description: 'Client cancel' },
      { value: 17, description: 'Sick' },
      { value: 18, description: 'Transport issue' },
      { value: 19, description: 'Other' }
    ]

    this.internalStatusChangeReasons = {
      ...this.statusChangeReasons,
      [enums.PayrollHoursStatus.REJECTED]: [
        { value: 7, description: 'Resigned' },
        { value: 8, description: 'No Show' },
        { value: 9, description: 'Walkoff' },
        { value: 23, description: 'Time Theft'},
        { value: 19, description: 'Other' }
      ]
    }

    this.allStatusChangeReasons = {}

    for (let reasonCategory in this.statusChangeReasons) {
      if (this.statusChangeReasons.hasOwnProperty(reasonCategory)) {
        this.statusChangeReasons[reasonCategory].forEach(reason => {
          if (!this.allStatusChangeReasons.hasOwnProperty(reason.value)) {
            this.allStatusChangeReasons[reason.value] = reason.description
          }
        })
      }
    }

    this.messagedOffsiteWarningReason = 20
    this.messagedLateWarningReason = 21
    this.messagedSubmitHoursReason = 22

    this.allStatusChangeReasons[20] = 'Off-site warning'
    this.allStatusChangeReasons[21] = 'Late warning'
    this.allStatusChangeReasons[22] = 'Submit hours'
    this.allStatusChangeReasons[23] = 'Time Theft'

    this.previewFormatValues = [
      { value: "EXCEL", name: "Excel spreadsheet (.xlsx)"},
      { value: "CSV", name: "Comma separated values (.csv)"}
    ]
    this.previewFormat = this.previewFormatValues[0].name
    this.previewFormatValue = this.previewFormatValues[0].value
    this.previewActive = false

    this.previewRegionValues = [
      { value: "main", name: ""},
      { value: "all", name: "All workplaces"}
    ]
    this.previewRegion = this.previewRegionValues[0].name
    this.previewRegionValue = this.previewRegionValues[0].value
    this.previewRegionActive = false

    this.previewDateActive = false
    this.previewEndDateActive = false
    this.setPreviewDate()

    this.getPayrollReport(week)

    this.initializeSplitWatcher()
  }

  initializeSplitWatcher() {
    this.Auth.getDetails().then(() => {
      const attributes = {
        account_type: this.Auth.me.accountType,
        company_id: this.Auth.me.companyId,
        company_name: this.Auth.me.companyName,
        userId: this.Auth.me.internalId
      };
      
      const destroy = this.$scope.$watch(
        () => {
          return this.Auth.splitClient.getTreatment(TIMETRACKING_LEGACY_VIEW_SPLIT_NAME, attributes);
        },
        (newVal) => {
          if (newVal === "off") {
            this.$window.location.replace(`${CONFIG.REACT_APP_BASE}/payroll`);
          }
        }
      );
      
      this.$scope.$on('$destroy', destroy);
    }).catch(error => {
      console.error('Failed to initialize timetracking split watcher:', error);
    });
  }

  getPayrollReport (week) {
    this.Auth.getDetails()
      .then(user => {
        this.user = user
        if (this.user.isInternal) {
          // internal users get their own customized list of reasons that are slightly different than that we present to clients
          this.statusChangeReasons = this.internalStatusChangeReasons
        }
        if (!user.can('VIEW_COMPANIES_TIMESHEETS')) {
          this.getCompanyPayroll(this.company.id)
        } else if (this.$stateParams.companyId) {
            this.getCompanyPayroll(this.$stateParams.companyId)
        } else {
          this.PayrollService.getPayrollReport({week: week})
            .then(response => {
              // why reate two arrays? - because original response has more fields
              // than used in table and as a result search could return weird results
              const companiesTableData = []
              const allCompaniesPayroll = []

              response.forEach(c => {
                if (this.user.region_id !== c.region_id &&
                  !this.user.can('VIEW_COMPANIES_TIMESHEETS_OUTSIDE_OWN_REGION')) {
                  return
                }

                allCompaniesPayroll[c.id] = c

                if (this.user.region_id === c.region_id || this.user.can('VIEW_COMPANIES_TIMESHEETS_OUTSIDE_OWN_REGION')) {
                  companiesTableData.push({
                    id: c.id,
                    name: c.name,
                    totalThisWeek: c.totalThisWeek,
                    needApprovalAllTime: c.needApprovalAllTime,
                    accountManagerName: c.accountManagerName,
                    region_id: c.region_id
                  })
                }
              })
              this.allCompaniesPayroll = allCompaniesPayroll
              this.companiesTableData = companiesTableData
              this.dataLoaded = true
            })
        }
      })
  }

  sortPayrollReportTable (column) {
    if (column === this.tableDisplay.column) {
      this.tableDisplay.reverse = !this.tableDisplay.reverse
    } else {
      this.tableDisplay.column = column
      if (column === 'totalThisWeek' || column === 'needApprovalAllTime') {
        this.tableDisplay.reverse = false
      } else {
        this.tableDisplay.reverse = true
      }
    }
  }

  setCompanyPayrollSettings (company) {
    /* company wide settings */
    this.late_tolerance = isFinite(company.late_tolerance) ? company.late_tolerance : 15
    this.min_offsite_radius = isFinite(company.min_offsite_radius) ? company.min_offsite_radius : 50
    this.min_lunch_duration = isFinite(company.min_lunch_duration) ? Math.round(company.min_lunch_duration * 60) : 30
    this.early_clockin_buffer = isFinite(company.early_clockin_buffer) ? company.early_clockin_buffer : 30
    this.terminalMode = company.terminal_mode ? company.terminal_mode : 0
    this.disable_radii_use = company.disable_radii_use ? company.disable_radii_use : false
    this.phoenixExperience = false
  }

  getCompanyPayroll (companyId) {
    this.dataLoaded = false
    this.$stateParams.companyId = companyId

    this.CompaniesService.getCompany(companyId)
    .then(company => {
      // bad API response, have to hack around it until fix
      company['external_id'] = company.id
      company.id = company.internal_id
      this.selectedCompany = company
      this.previewRegionValues[0].name = this.previewRegion = this.selectedCompany.name

      this.setCompanyPayrollSettings(company)
    })
    .then(() => {
      if (this.user.isInternal
          && this.selectedCompany.region_id !== this.user.region_id
          && !this.user.can('VIEW_COMPANIES_TIMESHEETS_OUTSIDE_OWN_REGION')) {
        this.ToastService.showWarning('This company is assigned to a region outside your level of permissions so you are unable to see this page.')
        return null
      }

      return this.PayrollService.fetchPayroll({
        companyId: this.selectedCompany.external_id,
        week: this.selectedWeek
      })
    })
    .then(this.processPayrollData.bind(this))
    .then(() => {
      this.mode = 'company'
      this.dataLoaded = true
    })
  }

  companyPayrollPage (companyId) {
    this.$state.go('app.payroll', {companyId: companyId})
  }

  getInvoiceTotal () {
    this.QCData = {
      columnDefs: [{
        name: '_index',
        type: 'text',
        width: 0,
        editing: false,
        css: 'jsgrid-overflow _index'
      }, {
        name: '_approved',
        type: 'text',
        width: 0,
        editing: false,
        css: 'jsgrid-overflow _approved'
      }, {
        name: 'Employee Name',
        type: 'text',
        width: 140,
        editing: false,
        css: 'jsgrid-overflow'
      }, {
        name: 'Address',
        type: 'text',
        width: 200,
        editing: false,
        css: 'jsgrid-overflow'
      }, {
        name: 'Job Date',
        type: 'text',
        sorter: dateSorter,
        width: 110,
        editing: false
      }, {
        name: 'Wage',
        type: 'number',
        sorter: monetarySorter,
        width: 60,
        editing: false
      }, {
        name: 'Markup',
        type: 'number',
        width: 60,
        editing: false,
        visible: this.selectedCompany.pricing === 0
      }, {
        name: 'Time In',
        type: 'text',
        width: 80,
        css: 'time-in'
        // editTemplate: textEditTemplateForType('timeIn')
      }, {
        name: 'Time Out',
        type: 'text',
        width: 80,
        css: 'time-out'
        // editTemplate: textEditTemplateForType('timeOut')
      }, {
        name: 'Lunch',
        type: 'number',
        width: 60,
        css: 'lunch'
        // editTemplate: textEditTemplateForType('lunch')
      }, {
        name: 'Total Hours',
        type: 'number',
        width: 60,
        editing: false,
        css: 'total-hours'
      }, {
        name: 'Reg Hours',
        type: 'number',
        width: 60,
        editing: false,
        css: 'regular-hours'
      }, {
        name: 'OT Hours',
        type: 'number',
        width: 60,
        editing: false,
        css: 'ot-hours'
      }, {
        name: 'DT Hours',
        type: 'number',
        width: 60,
        editing: false,
        css: 'dt-hours'
      }, {
        name: 'Reg cost/hr',
        sorter: monetarySorter,
        type: 'number',
        width: 80,
        editing: false
      }, {
        name: 'OT cost/hr',
        sorter: monetarySorter,
        type: 'number',
        width: 80,
        editing: false
      }, {
        name: 'Cost',
        sorter: monetarySorter,
        type: 'number',
        width: 80,
        editing: false,
        css: 'cost'
      }, {
        name: 'Service Fee',
        sorter: monetarySorter,
        type: 'number',
        width: 80,
        editing: false,
        css: 'service-fee',
        visible: this.selectedCompany.pricing === 1
      }],
      enableColumnMenus: false,
      enableSorting: false,
      data: []
    }
    this.PayrollService.fetchPayrollHours({
      companyId: this.selectedCompany.external_id,
      week: this.selectedWeek
    })
    .then((lineItem) => {
      for (const [i, user] of lineItem.entries()) {
        let markup = user.markup != null ? user.markup.toFixed(4) : '?'
        let cost_per_hour = user.cost_per_hour != null ? '$' + user.cost_per_hour.toFixed(2) : '?'
        let cost_per_hour_overtime = user.cost_per_hour_overtime != null ? '$' + user.cost_per_hour_overtime.toFixed(2) : '?'
        let cost = user.cost != null ? '$' + user.cost.toFixed(2) : '?'
        let costData = {
          '_index': i,
          '_approved': user.approved.toString(),
          'Employee Name': user.name,
          'Address': user.address,
          'Job Date': user.date,
          'Wage': '$' + user.wage.toFixed(2),
          'Markup': markup,
          'Time In': dateToTimeString(new Date(user.shift_start), true),
          'Time Out': dateToTimeString(new Date(user.shift_end), true),
          'Lunch': user.lunch_duration.toFixed(2),
          'Total Hours': user.total_hours.toFixed(2),
          'Reg Hours': user.regular_hours.toFixed(2),
          'OT Hours': user.overtime_hours.toFixed(2),
          'DT Hours': user.doubletime_hours.toFixed(2),
          'Reg cost/hr': cost_per_hour,
          'OT cost/hr': cost_per_hour_overtime,
          'Cost': cost,
          'Service Fee': '$' + user.service_fee.toFixed(2)
        }
        this.QCData.data.push(costData)
      }
    })
  }

  getLatestTimestamp(timestamps) {
    return timestamps.reduce((t1, t2) => {
      if (t1.updatedAt < t2.updatedAt) {  // Dates are received as ISO 8601 string
        return t2;
      }
      return t1;
    }, timestamps[0]);
  }

  /**
   * @typedef {Object} lunchDurations
   * @property {Number} lunchDuration - In minutes, calculated lunch duration
   * @property {Number} clockedLunchDuration - In minutes, clocked in lunch duration. Will be null if CM did not take lunch
   */

  /**
   * Calculates lunch duration to display using timestamps on the user object, or users_hours lunchDuration
   * @param {any} user - A user object, which should have timestamps
   * @returns {lunchDurations} A pair of attributes in an object: lunchDuration & clockedLunchDuration
   */
   calculateLunchDurationForDisplay(user) {
    const lunchStartTimestamps = user.timestamps.filter((t) => t.type === "LUNCH_START");
    const lunchEndTimestamps = user.timestamps.filter((t) => t.type === "LUNCH_END");

    // Ticket for tracking mirrored rules between CM and WP:
    // https://bluecrewjobs.atlassian.net/browse/BW-874
    // TODO:(BW-874) Remove mirrored rules, get breaks from...?

    // NOTE: Lunch Duration as used for billing is set by CM in users_hours upon shift completion
    // Lunch duration HERE is for display purposes. It can be edited in the page by a user, however.

    // NOTE: How lunch duration is handled here will change with updates to biz requirements around breaks. See ticket.

    // Defaults for lunch duration
    // Only used if a user did not clock a lunch
    const defaultLunchDuration = (user.defaultLunchDuration ?? this.min_lunch_duration) * 60
    const defaultClockedLunchDuration = null
    const defaultDurations = {
      lunchDuration: defaultLunchDuration,
      clockedLunchDuration: defaultClockedLunchDuration,
    };

    // If a shift is finished...
    // -----------------------------------------------------------------------
    // I.E. a CM has tapped "submit for approval",
    // I.E. a CM has submitted their timestamps for review, then users_hours
    // will be populated. This means the lunch duration on the user object will
    // be defined and we can pull lunch duration from that
    if (!!user.lunchDuration) {
      // user.lunchDuration is stored in hours, so
      // convert to minutes to display on the page
      const lunchDuration = Math.floor(user.lunchDuration * 60)
      const clockedLunchDuration = lunchDuration
      return {lunchDuration, clockedLunchDuration}
    }

    // If a shift is still in progress...
    // -----------------------------------------------------------------------
    // Then users_hours will not be populated, so the current break total must
    // be calculated by looking at timestamps on the user object
    if (lunchStartTimestamps.length > 0 && lunchEndTimestamps.length > 0) {
      // Check that both lists are the same length. Start can contain
      // 1 more timestamp than End if a CM is currently on break
      if (lunchStartTimestamps.length === lunchEndTimestamps.length + 1) {
        // Remove the last lunch start time stamp so both lists are the same length
        lunchStartTimestamps.pop()
      }

      // In any other scenario, if the two lists of timestamps don't match
      // in length (except for the above scenario) then log an error
      if (lunchStartTimestamps.length !== lunchEndTimestamps.length) {
        // I think we were probably logging to new relic previously. Should update to log to CloudWatch
        console.log(
          "Could not calculate a lunch duration from timestamps because" +
            "CM has a different amount of lunch start timestamps vs lunch end timestamps. " +
            `CM external id: ${user.external_id}, ` +
            `Lunch Start Timestamps: ${lunchStartTimestamps.length}, ` +
            `Lunch End Timestamps: ${lunchEndTimestamps.length}`
        )
        return defaultDurations
      }

      // If start and end timestamps are the same length,
      // then we can calculate lunch duration from them
      const lunchTimestamps = zip(lunchStartTimestamps, lunchEndTimestamps)

      const lunchBreaks = lunchTimestamps
        // Map timestamps to break durations
        .map((pair) => {
          const [lunchStart, lunchEnd] = pair
          return differenceInMinutes(lunchEnd.time, lunchStart.time)
        })
        // Mirror rule from CM: Filter out breaks less than 20 minutes in length
        // TODO:(BW-874) Remove filtering rule
        // https://github.com/Bluecrew/crew-member-backend/pull/616
        .filter((lunchBreak) => lunchBreak >= 20)

      if (lunchBreaks.length === 0){
        // Return the defaults if all breaks were < 20 min and were filtered out
       return defaultDurations
      }

      const lunchDuration = sum(lunchBreaks)
      const clockedLunchDuration = lunchDuration
      return {lunchDuration, clockedLunchDuration}
    }

    return defaultDurations
  }

  processPayrollData (payroll) {
    if (typeof payroll.users !== 'undefined') { this.users = payroll.users };
    if (typeof payroll.jobs !== 'undefined') { this.jobs = payroll.jobs };

    this.shiftsByDate = {}

    let payrollDates = []
    if (payroll.payroll.companies) {
      /* yes, it's stupid, but this is how API returns data... */
      let companyPayroll = payroll.payroll.companies[0]
      let shiftsByDate = {}
      let firstDate = true
      let that = this

      payrollDates = companyPayroll.dates
      companyPayroll.dates.forEach(dateJobs => {
        const date = dateJobs.date

        if (date > format(new Date(), 'YYYY-MM-DD')) {
          return
        }

        shiftsByDate[date] = {}
        shiftsByDate[date]['total'] = 0

        for (const key in this.PayrollHoursStatus) {
          if (this.PayrollHoursStatus.hasOwnProperty(key)) {
            shiftsByDate[date][this.PayrollHoursStatus[key]] = []
          }
        }

        const jobs = dateJobs.jobs

        jobs.forEach(job => {
          const users = job.users

          users.forEach(user => {
            if (typeof user.status === 'undefined') {
              user.status = this.PayrollHoursStatus.NEEDS_VERIFICATION
            }
            // as we are migrating HIDDEN status to NO_RESPONSE, fixing it here:
            if (typeof user.status !== 'undefined' && user.status === this.PayrollHoursStatus.HIDDEN) {
              user.status = this.PayrollHoursStatus.NO_RESPONSE
            }

            let usersGroup = user.status

            // timestamps in different format, converting it to work with time picker
            for (let i = 0; i < user.timestamps.length; i++) {
              let date = new Date(user.timestamps[i].time)
              user.timestamps[i].time = date.setSeconds(0, 0)
            }

            user['jobId'] = job.id
            user['firstName'] = this.users[user.id].firstName
            user['lastName'] = this.users[user.id].lastName
            user['vensureId'] = this.users[user.id].vensureId
            user['bcId'] = this.users[user.id].id
            user['start'] = new Date(job.start)
            user['end'] = new Date(job.end)
            user['shift'] = job.shift

            defaultPositionRadii(job)

            user['warnRadius'] = this.disable_radii_use ? 0 : job.min_warn_radius
            user['blockRadius'] = this.disable_radii_use ? 0 : job.min_block_radius

            // instantiate properties for future use
            user['selected'] = false
            user['error'] = null

            user['jobId'] = job.id
            user['shiftStart'] = new Date(job.start)
            user['shiftEnd'] = new Date(job.end)
            user['isOvernightShift'] = getDay(job.start) != getDay(job.end)

            user['expectedStart'] = moment(user.shiftStart).format('h:mm a')
            user['expectedEnd'] = moment(user.shiftEnd).format('h:mm a')
            user['sheduledShiftDuration'] = differenceInMinutes(job.end, job.start) / 60
            user['defaultLunchDuration'] = job.default_lunch_duration

            const shiftStartTimestamps = user.timestamps.filter(t => t.type === 'SHIFT_START')
            const shiftEndTimestamps = user.timestamps.filter(t => t.type === 'SHIFT_END')

            user['clockedTimestamps'] = {
              start: shiftStartTimestamps.length > 0 ? this.getLatestTimestamp(shiftStartTimestamps) : null, // using latest clock-in submission
              end: shiftEndTimestamps.length > 0 ? this.getLatestTimestamp(shiftEndTimestamps) : null // // using latest clock-out submission
            }

            user['clockedInDayAfterOvernightShiftStarts'] = user.isOvernightShift && user.clockedTimestamps.start && getDay(job.start) != getDay(user.clockedTimestamps.start.time)
            user['allowStartPrevDay'] = !user.isOvernightShift || user.clockedInDayAfterOvernightShiftStarts
            user['allowStartNextDay'] = user.isOvernightShift && !user.clockedInDayAfterOvernightShiftStarts

            user['clockedOutDayBeforeOvernightShiftEnds'] = user.isOvernightShift && user.clockedTimestamps.end && getDay(job.end) != getDay(user.clockedTimestamps.end.time)
            user['allowEndPrevDay'] = user.isOvernightShift && !user.clockedOutDayBeforeOvernightShiftEnds
            user['allowEndNextDay'] = !user.isOvernightShift || user.clockedOutDayBeforeOvernightShiftEnds

            user['editedTimes'] = {
              start: user.clockedTimestamps.start ? new Date(user.clockedTimestamps.start.time) : user.shiftStart,
              end: user.clockedTimestamps.end ? new Date(user.clockedTimestamps.end.time) : user.shiftEnd
            }

            user['isEdited'] = {
              start: false,
              end: false
            }

            const { lunchDuration, clockedLunchDuration } = this.calculateLunchDurationForDisplay(user)
            user['clockedLunchDuration'] = clockedLunchDuration
            user['lunch'] = lunchDuration

            user.reasonDescription = user.reason >= 0
            ? this.allStatusChangeReasons[user.reason]
            : null

            user.crewMemberConfirmedTime = moment(user.crewMemberConfirmedAt).format('MM/DD/YYYY h:mm a')

            if (shiftsByDate[date][usersGroup]) {
              shiftsByDate[date][usersGroup].push(user)
              shiftsByDate[date].total++
            }
            if (firstDate) {
              that.selectedDate = date
              firstDate = false
            }
          })
        })

        shiftsByDate[date][this.PayrollHoursStatus.APPROVED].sort((a, b) => {
          return a.lastName === b.lastName ? 0 : a.lastName > b.lastName ? 1 : -1
        })

        let hoursReadyForApproval = []
        let hoursWithMiscIssues = []
        let hoursWithNoTimestamps = []

        for (const status of ['NEEDS_VERIFICATION', 'FOLLOW_UP']) {

          if (shiftsByDate[date][this.PayrollHoursStatus[status]]) {
              shiftsByDate[date][this.PayrollHoursStatus[status]].forEach(job => {
                let hasIssues = false
                let noTimestamps = false

                const geo = jobs.filter((x) => {
                  return x.id === job.jobId
                })
                for (let i = 0; i < job.timestamps.length; i++) {
                  job.timestamps[i]['warnGeofenceMessage'] = ''
                  job.timestamps[i]['blockGeofenceMessage'] = ''
                   if ((!this.disable_radii_use) && (geo) && (geo[0])) {
                      if ((job.timestamps[i].type === 'SHIFT_START' || job.timestamps[i].type === 'SHIFT_END')) {
                        const msg = (job.timestamps[i].type === 'SHIFT_START') ? 'clock-in' : 'clock-out'
                        const measure = job.timestamps[i].distance >= 1000 ? 'km' : 'm'
                        const distance = toMetric(job.timestamps[i].distance).toFixed(measure === 'km' ? 1 : 0)

                        if (job.timestamps[i].distance >= geo[0].min_block_radius) {
                          job.timestamps[i]['blockGeofenceMessage'] = msg + ' ' + distance + measure
                          hasIssues = true
                        }
                        else if (job.timestamps[i].distance >= geo[0].min_warn_radius) {
                          job.timestamps[i]['warnGeofenceMessage'] = msg + ' ' + distance + measure
                          hasIssues = true
                        }
                      }
                  }
                }

                if (job.timestamps.length === 0) {
                  noTimestamps = true
                } else if (job.timestamps.length === 0) {
                  hasIssues = true
                }

                // categorizing here should only be done for those shifts with status NEEDS_VERIFICATION
                // otherwise follow ups will show up in the needs verification tab
                if (status === 'NEEDS_VERIFICATION') {
                  if (noTimestamps) {
                    hoursWithNoTimestamps.push(job)
                  } else {
                    if (hasIssues) {
                      hoursWithMiscIssues.push(job)
                    } else {
                      hoursReadyForApproval.push(job)
                    }
                  }
                }
              })
          }
        }


        hoursReadyForApproval.sort((a, b) => { return a.lastName === b.lastName ? 0 : a.lastName > b.lastName ? 1 : -1 })
        hoursWithMiscIssues.sort((a, b) => { return a.lastName === b.lastName ? 0 : a.lastName > b.lastName ? 1 : -1 })
        hoursWithNoTimestamps.sort((a, b) => { return a.lastName === b.lastName ? 0 : a.lastName > b.lastName ? 1 : -1 })

        shiftsByDate[date][this.PayrollHoursStatus.NEEDS_VERIFICATION] = hoursReadyForApproval.concat(hoursWithMiscIssues).concat(hoursWithNoTimestamps)
      })

      this.shiftsByDate = shiftsByDate
    }
    this.payrollDates = payrollDates
  }

  updatePayrollWeek (day) {
    let weeksSinceEpoch = Math.floor((day - 3.744e5) / 6.048e5 / 1000)
    this.selectedWeek = weeksSinceEpoch
    this.startDateOfWeek = day
    this.mode === 'company'
    ? this.getCompanyPayroll(this.selectedCompany.id)
    : this.getPayrollReport(this.selectedWeek)
  }

  /* #region user hours status change actions */

  bulkAction (fromStatus, newStatus, reason, note) {
    const shiftsForBulkAction = []
    this.shiftsByDate[this.selectedDate][fromStatus].forEach(shift => {
      if (shift.error) {
        shift.selected = false
      } else if (shift.selected) {
        shiftsForBulkAction.push(shift)
      }
    })

    shiftsForBulkAction.forEach(shift => {
      this.changeHoursStatus(shift, newStatus, reason, note, false)
    })

    const message = newStatus === this.PayrollHoursStatus.APPROVED
      ? shiftsForBulkAction.length + ' users approved'
      : 'Status updated for ' + shiftsForBulkAction.length + (shiftsForBulkAction.length == 1 ? ' worker' : ' workers')

    this.$mdToast.showSimple(message)
  }

  showSingleActionDialog (user, newStatus) {
    this.$mdDialog.show({
      clickOutsideToClose: true,
      controller: actionReasonController,
      controllerAs: 'ctrl',
      template: actionReasonTemplate,
      locals: {
        reasonOptions: this.statusChangeReasons[newStatus],
        newStatus
      }
    })
    .then(data => {
      this.changeHoursStatus(user, newStatus, data.reason, data.note)
    })
    .catch(() => {})
  }

  showBulkActionDialog (fromStatus, newStatus) {
    if (fromStatus === this.PayrollHoursStatus.NEEDS_VERIFICATION
      && (newStatus === this.PayrollHoursStatus.APPROVED || newStatus === this.PayrollHoursStatus.FOLLOW_UP)) {
      this.bulkAction(fromStatus, newStatus, null, null)
    } else {
      this.$mdDialog.show({
        clickOutsideToClose: true,
        controller: actionReasonController,
        controllerAs: 'ctrl',
        template: actionReasonTemplate,
        locals: {
          reasonOptions: this.statusChangeReasons[newStatus],
          newStatus
        }
      })
      .then(data => {
        this.bulkAction(fromStatus, newStatus, data.reason, data.note)
      })
      .catch(() => {})
    }
  }

  approveHours (user, reason, note, showNotification = true) {
    if (user.error) {
      this.$mdToast.showSimple('Invalid hours')
      return false
    }

    const shiftStart = user.clockedTimestamps.start && !user.isEdited.start ? user.clockedTimestamps.start.time : user.editedTimes.start
    const shiftEnd = user.clockedTimestamps.end && !user.isEdited.end ? user.clockedTimestamps.end.time : user.editedTimes.end

    /*
      lunch calculation business logic:
      if shift is < 5 hours, deduct clocked/edited lunch length, do not deduct anything if lunch not clocked
      if shift is > 5 hours and lunch not clocked, deduct company lunch minimum length
      if shift is > 5 hours and lunch is clocked/edited, deduct larger of clocked/edit value or company lunch minimum length
    */

    const requestData = {
      userId: user.id,
      jobId: user.jobId,
      shift: user.shift,
      shiftStart: shiftStart,
      shiftEnd: shiftEnd,
      lunchDuration: user.lunch !== null ? (user.lunch / 60) : (this.min_lunch_duration / 60),
      reason: reason,
      note: note
    }

    this.PayrollService
    .approveShift(requestData)
    .catch(err => {
      this.$mdToast.showSimple(err)
    })
    .then(res => {
      if (showNotification) {
        this.$mdToast.showSimple('1 user approved')
      }
      user.hoursId = res.data
      this.getInvoiceTotal()
    })

    user.hoursStart = shiftStart
    user.hoursEnd = shiftEnd
    user.lunchDuration = user.lunch !== null ? (user.lunch / 60) : (this.min_lunch_duration / 60)

    return true
  }

  undoHours (user) {
    this.PayrollService
      .undoHours({hoursId: user.hoursId})
      .catch(err => {
        this.$mdToast.showSimple(err)
      })
      .then(() => {
        user.reason = null
        user.reasonDescription = null
        user.note = null
        user.markedLate = 0
        user.markedLateByName = null
        user.markedLateByFirstName = null
        user.markedLateByLastName = null
        user.updatedByName = null
        user.updatedByFirstName = null
        user.updatedByLastName = null
        user.updatedByPermission = null
        this.moveUserBetweenGroups(user, this.PayrollHoursStatus.NEEDS_VERIFICATION)
        if (user.status === this.PayrollHoursStatus.APPROVED) {
          this.getInvoiceTotal()
        }
      })
  }

  changeHoursStatus (user, newStatus, reason, note, showNotification) {
    if (newStatus === this.PayrollHoursStatus.NEEDS_VERIFICATION) {
      this.undoHours(user)
    } else if (newStatus === this.PayrollHoursStatus.APPROVED) {
      if (user.status === this.PayrollHoursStatus.NEEDS_VERIFICATION) {
        reason = 0
      }
      this.approveHours(user, reason, note, showNotification)
    } else {
      this.PayrollService
        .updateHoursStatus(newStatus, user.id, user.jobId, user.shift, reason, note)
        .then(res => {
          user.hoursId = res.data
        })
        .catch(err => {
          this.$mdToast.showSimple(err)
        })
    }

    user.updatedByName = newStatus !== this.PayrollHoursStatus.NEEDS_VERIFICATION ? this.user.firstName + ' ' + this.user.lastName : null
    user.updatedByFirstName = newStatus !== this.PayrollHoursStatus.NEEDS_VERIFICATION ? this.user.firstName : null
    user.updatedByLastName = newStatus !== this.PayrollHoursStatus.NEEDS_VERIFICATION ? this.user.lastName : null
    user.updatedByPermission = newStatus !== this.PayrollHoursStatus.NEEDS_VERIFICATION ? this.user.updatedByPermission : null
    user.reason = reason
    user.reasonDescription = user.reason >= 0 ? this.allStatusChangeReasons[user.reason] : null
    user.note = note

    this.moveUserBetweenGroups(user, newStatus)
  }

  moveUserBetweenGroups (user, newStatus) {
    const date = this.selectedDate
    const indexOfUser = findIndex(propEq('id', user.id))(this.shiftsByDate[date][user.status])

    if (newStatus === this.PayrollHoursStatus.NEEDS_VERIFICATION) {
      user['editedTimes'] = {
        start: user.clockedTimestamps.start ? new Date(user.clockedTimestamps.start.time) : user.shiftStart,
        end: user.clockedTimestamps.end ? new Date(user.clockedTimestamps.end.time) : user.shiftEnd
      }
      user.isEdited = {
        start: false,
        end: false
      }
    }

    if (indexOfUser > -1) {
      user.selected = false
      this.shiftsByDate[date][newStatus].push(user)
      this.shiftsByDate[date][user.status].splice(indexOfUser, 1)
    }

    user.status = newStatus
  }

  /* #endregion */

  selectOrDeselectAllShifts (status, selected) {
    this.shiftsByDate[this.selectedDate][status].forEach(shift => {
      shift.selected = selected && !shift.error
    })
  }

  atLeastOneUserIsSelected (status) {
    for (let i = 0; i < this.shiftsByDate[this.selectedDate][status].length; i++) {
      if (this.shiftsByDate[this.selectedDate][status][i].selected) {
        return true
      }
    }

    return false
  }

  calcTotalHours (user) {
    if (user.status === this.PayrollHoursStatus.APPROVED) {
      const minutes = differenceInMinutes(new Date(user.hoursEnd), new Date(user.hoursStart))
      return (minutes / 60 - user.lunchDuration).toFixed(2)
    }

    if (user.lunch != parseInt(user.lunch)) {
      user.error = 'invalid lunch value'
      return ''
    }

    let start = null
    let end = null

    if (user.isEdited.start) {
      start = user.editedTimes.start
    } else if (user.clockedTimestamps.start) {
      start = user.clockedTimestamps.start.time
    } else {
      start = user.shiftStart
    }
    start = user.editedTimes.start

    if (user.isEdited.end) {
      end = user.editedTimes.end
    } else if (user.clockedTimestamps.end) {
      end = user.clockedTimestamps.end.time
    } else {
      end = user.shiftEnd
    }
    end = user.editedTimes.end

    if (start === null || end === null) {
      user.error = 'missing start or end'
      return ''
    } else {
      if (start > end) {
        user.error = 'start can\'t be after end'
        return ''
      }
      const hours = this.Shifts.calcTotalHours(start, end, user.lunch)
      if (hours < 0) {
        user.error = 'hours can\'t be negative'
        return ''
      }

      if (hours > 24) {
        user.error = 'hours can\'t be more than 24 hours'
        return ''
      }

      user.error = null
      return hours
    }
  }

  getMessage (reason) {
    const messages = {
      20: {
        text: `Hi, your clock ins were off the job site on ${format(this.selectedDate, 'MMMM Do')}. This is an official warning. You have 8 hours to submit your correct times for review on live support.`,
        category: 'off-site warning'
      },
      21: {
        text: 'Hi, you have been reported as showing up late to work. This is an official warning. Further violations will result in a review of your employment status.',
        category: 'late-warning'
      },
      22: {
        text: `Hi, you submitted no clock in data through the app for your job on ${format(this.selectedDate, 'MMMM Do')}. You have 8 hours to submit your times for review on live support.`,
        category: 'submit-hours'
      }
    }

    return messages[reason]
  }

  showSingleUserMessageDialog (user, reason) {
    const message = this.getMessage(reason)

    this.$mdDialog.show({
      parent: document.body,
      template: messageTemplate,
      locals: {
        users: [user],
        message: message.text,
        messageCategory: message.category
      },
      controller: messageController,
      controllerAs: 'm'
    })
    .then(() => {
      if (user.status === this.PayrollHoursStatus.NEEDS_VERIFICATION) {
        this.changeHoursStatus(user, this.PayrollHoursStatus.FOLLOW_UP, reason)
      }
    })
    .catch(() => {})
  }

  showGroupMessageDialog (reason, status) {
    const selectedUsers = []

    this.shiftsByDate[this.selectedDate][status].forEach(user => {
      if (user.selected) {
        selectedUsers.push(user)
      }
    })

    const message = this.getMessage(reason)

    this.$mdDialog.show({
      parent: document.body,
      template: messageTemplate,
      locals: {
        message: message.text,
        users: selectedUsers,
        messageCategory: message.category
      },
      controller: messageController,
      controllerAs: 'm'
    })
    .then(() => {
      if (status === this.PayrollHoursStatus.NEEDS_VERIFICATION) {
        this.bulkAction(status, this.PayrollHoursStatus.FOLLOW_UP, reason)
      }
    })
    .catch(() => {})
  }

  showCurrentJobs () {
    let selectJob = {
      controller: showJobsCtrl,
      controllerAs: 'add',
      template: showJobsTpl,
      fullscreen: true,
      clickOutsideToClose: true,
      hasBackdrop: true,
      locals: {
        company: this.selectedCompany,
        Companies: this.CompaniesService,
        Jobs: this.JobsService,
        Users: this.UsersService,
        Crews: this.Crews,
        $mdDialog: this.$mdDialog,
        $mdToast: this.$mdToast,
        user: this.user
      }
    }
    this.$mdDialog.show(selectJob)
    .then(res => { if (res === 'reload') this.reloadTimestamps() })
  }

  reloadTimestamps () {
    this.getCompanyPayroll(this.$stateParams.companyId)
  }

  showAddNoteDialog (user) {
    const userToAddNote = this.users[user.id]
    userToAddNote['id'] = user.id

    this.$mdDialog.show({
      parent: document.body,
      template: noteTemplate,
      locals: {
        user: userToAddNote
      },
      controller: noteController,
      controllerAs: 'n'
    })
  }

  sendMassPayment () {
    let confirm = this.$mdDialog.confirm()
    .title('Run Dwolla batch payments')
    .textContent('Confirm that you want to batch run Dwolla payments')
    .ariaLabel('confirm')
    .ok('Confirm run')
    .cancel('Cancel')

    this.$mdDialog.show(confirm)
      .then(
        () => {
          this.PayrollService.sendMassPayment()
            .then(res => {
              this.ToastService.showError(null, res)
            })
            .catch(err => {
              this.ToastService.showError(err)
            })
        },
        () => {}
      )
  }

  details (user) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: detailsTemplate,
      locals: {
        user: this.users[user.id],
        timestamps: user.timestamps,
        job: this.jobs[user.jobId],
        minOffsite: user.warnRadius,
      },
      fullscreen: true,
      controller: detailsController,
      controllerAs: 't'
    })
  }

  onlySundayPredicate (date) {
    var day = date.getDay()
    return day === 1
  }

  cancelTimeEdit (user, type) {
    user.editedTimes[type] = new Date(user.clockedTimestamps[type].time)
    user.isEdited[type] = false
  }

  addDayToEditedTime (user, type) {
    user.editedTimes[type] = addHours(user.editedTimes[type], 24)
  }

  substractDayFromEditedTime (user, type) {
    user.editedTimes[type] = subHours(user.editedTimes[type], 24)
  }

  openInvoicePreview (event) {
    const parentEl = document.body
    this.$mdDialog.show({
      contentElement: '#invoiceDownloadPreview',
      parent: parentEl,
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
    //close any dropdowns that were open. set begin date so we know when date changes.
    //make sure start date is less than end date.
    //
    this.previewDateActive = false
    this.previewEndDateActive = false
    this.previewRegionActive = false
    this.previewActive = false
    this.invoiceStartDateOfWeek = (this.startDateOfWeek < this.invoiceStartDateOfWeek) ? this.startDateOfWeek : this.invoiceStartDateOfWeek
    this.beginInvoiceWeek = this.invoiceStartDateOfWeek
    this.setPreviewDate()
  }
  onPreviewActive(event) {
    this.previewDateActive = false
    this.previewEndDateActive = false
    this.previewRegionActive = false
    this.previewActive = !this.previewActive
  }
  onPreviewSelected(val) {
    var result = this.previewFormatValues.filter(x => { return x.value === val})
    if ((result) && (result.length > 0)) {
      this.previewFormat = result[0].name
      this.previewFormatValue = result[0].value
    }
    this.previewActive = false
  }

  onPreviewRegionActive(event) {
    this.previewDateActive = false
    this.previewEndDateActive = false
    this.previewActive = false
    this.previewRegionActive = !this.previewRegionActive
  }
  onPreviewRegionSelected(val) {
    var result = this.previewRegionValues.filter(x => { return x.value === val})
    if ((result) && (result.length > 0)) {
      this.previewRegion = result[0].name
      this.previewRegionValue = result[0].value
    }
    this.previewRegionActive = false
  }

  onPreviewDateActive($event) {
    this.beginInvoiceWeek = this.invoiceStartDateOfWeek
    this.previewRegionActive = false
    this.previewActive = false
    this.previewEndDateActive = false
    this.previewDateActive = !this.previewDateActive
    this.setPreviewDate()
  }
  onPreviewEndDateActive($event) {
    this.beginInvoiceWeek = this.invoiceStartDateOfWeek
    this.previewRegionActive = false
    this.previewActive = false
    this.previewDateActive = false
    this.previewEndDateActive = !this.previewEndDateActive
    this.setPreviewDate()
  }
  onPreviewDateClick() {
    if (this.beginInvoiceWeek !== this.invoiceStartDateOfWeek) {
      this.previewDateActive = !this.previewDateActive
    }
    this.setPreviewDate()
  }
  onPreviewEndDateClick() {
    if (this.beginInvoiceWeek !== this.invoiceEndDateOfWeek) {
      this.previewEndDateActive = !this.previewEndDateActive
    }
    this.setPreviewDate()
  }
  setPreviewDate() {
    if (this.invoiceStartDateOfWeek > this.invoiceEndDateOfWeek) {
      this.invoiceStartDateOfWeek = this.invoiceEndDateOfWeek
    }
    this.previewDate = ("0"+(this.invoiceStartDateOfWeek.getMonth()+1)).slice(-2) + "/" + ("0" + this.invoiceStartDateOfWeek.getDate()).slice(-2) + "/" + this.invoiceStartDateOfWeek.getFullYear()
    this.previewEndDate = ("0"+(this.invoiceEndDateOfWeek.getMonth()+1)).slice(-2) + "/" + ("0" + this.invoiceEndDateOfWeek.getDate()).slice(-2) + "/" + this.invoiceEndDateOfWeek.getFullYear()
  }
  closeInvoice () {
    this.$mdDialog.cancel()
  }
  downloadInvoicePreview (event) {
    var allInvoices = this.previewRegionValue === "all"
    var fileFormat = this.previewFormatValue
    let weeksSinceEpochStart = Math.floor((this.invoiceStartDateOfWeek - 3.744e5) / 6.048e5 / 1000)
    let query = {companyId: this.selectedCompany.external_id, week: weeksSinceEpochStart, pullAllChildInvoices: allInvoices, fileFormat: fileFormat}

    if (this.invoiceStartDateOfWeek !== this.invoiceEndDateOfWeek) {
      let weeksSinceEpochEnd = Math.floor((this.invoiceEndDateOfWeek  - 3.744e5) / 6.048e5 / 1000)
      query = {companyId: this.selectedCompany.external_id, week: weeksSinceEpochStart, weekEnd: weeksSinceEpochEnd, pullAllChildInvoices: allInvoices, fileFormat: fileFormat}
    }
    this.closeInvoice()
    this.$mdToast.showSimple('Downloading Invoice Preview')

    this.PayrollService.fetchInvoicePreview(query)
      .then((res) => {
        let file = new Blob([res], {type: fileFormat === "CSV" ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        let fileName = this.selectedCompany.name.replace(/[^a-zA-Z ]/g, '').replace(/\s+/g, '-') + '-' + moment(this.startDateOfWeek).format('YYYY-MM-DD')
        let fileURL = URL.createObjectURL(file)

        let a = document.createElement('a')
        a.href = fileURL
        a.target = '_blank'
        a.download = fileName + (fileFormat === "CSV" ? '.csv' : '.xlsx')
        document.body.appendChild(a)
        a.click()
      })
      .catch((res) => {
        if (res.status === 404) {
          return this.$mdToast.showSimple(`No hours approved for the specified dates`)
        }
        return this.$mdToast.showSimple('Invoice Error')
      })
  }

  updateVensureIds () {
    this.PayrollService.updateVensureIds({
      username: this.username,
      password: this.password,
      startDateOfWeek: this.newHireStartDateOfWeek,
      endDateOfWeek: this.newHireEndDateOfWeek
    })
    .then((data))
  }

  showNewHireCSV (ev) {
    const parentEl = document.body
    this.$mdDialog.show({
      contentElement: '#newHireCSV',
      parent: parentEl,
      targetEvent: ev,
      clickOutsideToClose: true
    })
    this.newHireStartDateOfWeek = this.startDateOfWeek
    this.newHireEndDateOfWeek = this.startDateOfWeek
  }

  getNewHireCSV () {
    let data = {
      privateKey: this.privateKey
    }
    if (this.newHireEmail) {
      data.email = this.newHireEmail
    } else {
      data.startDateOfWeek = this.newHireStartDateOfWeek
      data.endDateOfWeek = this.newHireEndDateOfWeek
    }

    this.PayrollService.newHireCSV(data)
    .then((res) => {
      let file = new Blob([res.data], {type: 'application/csv'})
      let fileName = 'newhires-' + this.newHireStartDateOfWeek + '-' + this.newHireEndDateOfWeek
      let fileURL = URL.createObjectURL(file)

      let a = document.createElement('a')
      a.href = fileURL
      a.target = '_blank'
      a.download = fileName + '.csv'
      document.body.appendChild(a)
      a.click()
    })
    .catch(() => {
      return this.$mdToast.showSimple('Error downloading CSV')
    })
  }

}

export default PayrollController
